import React from 'react';
import { HttpErrorDto } from '@common/dto/http';

export const FORMAT_MANAGEMENT_MODE = {
    save: 'save',
    load: 'load',
} as const;

export type FormatManagementMode = typeof FORMAT_MANAGEMENT_MODE[keyof typeof FORMAT_MANAGEMENT_MODE];

export type FormatManagementFormat = {
    id: number | null;
    name: string | null;
    description?: string;
    [key: string]: any;
};

export type FormatManagementFolder = {
    id: number;
    name?: string;
    [key: string]: any;
};

export type FormatManagementTableColumn = {
    label: string;
    field: string;
};

export type FormatManagementGetId = {
    modalTitle?: string;
    creatingFolderName?: string | ((args: any) => string);
    creatingFolderItem?: string | ((args: any) => string);
    creatingFolderCollapseItem?: string | ((args: any) => string);
    creatingFolderCancelBtn?: string;
    creatingFolderCreateBtn?: string;
    field?: (params: any) => string;
    newFolderBtn?: string;
    deleteFolderBtn?: string;
    deleteFormatBtn?: string;
    cancelBtn?: string;
    submitBtn?: string;
    folder?: string | ((args: any) => string);
    collapseIcon?: string | ((args: any) => string);
    [key: string]: any;
};

export interface FormatManagementProps {
    formats?: Array<FormatManagementFormat | { id: number | null; name: string | null; [key: string]: any }> | any[];
    deleteFormatBtnProps?: {
        text?: string;
    };
    submitBtnProps?: {
        text?: string;
    };
    folders?: Array<FormatManagementFolder | { id: number; name?: string; [key: string]: any }> | any[];
    title?: string;
    close: () => void;
    getFolders: () => Promise<void>;
    getFormats?: (folderId: number) => Promise<void>;
    isAllowedToSubmit?: (params: any) => boolean;
    selectedFormat?: FormatManagementFormat | { id: number; name: string; [key: string]: any };
    selectedFolder?: FormatManagementFolder | { id: number; name?: string; [key: string]: any };
    showFormatNameHeader?: boolean;
    formatNameInputLabel?: string;
    showDescriptionInput?: boolean;
    initialFormatName?: string;
    initialFormatDescription?: string;
    mode?: FormatManagementMode;
    formatsTableColumns?: FormatManagementTableColumn[];
    onSubmit?: (format?: any, folder?: any) => Promise<void> | void;
    onFormatDelete?: (...args: any[]) => Promise<void> | void;
    onFolderDelete?: (...args: any[]) => Promise<void> | void;
    onFolderCreate?: (data: any) => Promise<any>;
    resetFormats?: () => void;
    getId?: FormatManagementGetId;
    formatDescriptionInputLabel?: string;
    shouldRenderFormatName?: boolean;   
    onFormatRename?: (folderId: number, formatId: number, formatName: string) => void;
}

export interface FormatManagementState {
    messageProps: {
        header: string;
        text: string;
        show: boolean;
        confirmText: string;
        cancelText: string;
        size: string;
        onCustomOk: () => void;
        content?: React.ReactNode;
    };
    loadingFolders: boolean;
    formatName: string;
    formatDescription: string;
    selectedFolderId: number | null;
    selectedFormatId: number | null;
    isFolderCreatingOpened: boolean;
}

export type FormatManagementError = HttpErrorDto | Error | { entity?: string; [key: string]: unknown };

export type FolderCreateData = {
    parentId: number | null;
    name: string;
};

export type FormatSubmitData = {
    folderId: number | null;
    name: string;
    description?: string;
};
